import { EnumFlyingNicheSize } from '@domains/research/shared';
import { EnumAmazonMarketplace } from '@apps/flying/shared';
import { EnumLanguage } from '@libs/constants';


/**------------------------------------------------------
 * Enum Definitions
 */
export { EnumFlyingNicheSize } from '@domains/research/shared';


/**------------------------------------------------------
 * Data Structure
 */
export interface IFlyingNicheSuggestions {
	search			: string;
	size			: EnumFlyingNicheSize;
	market			: EnumAmazonMarketplace;
	language		: EnumLanguage;
	suggestions		: string[];
}
